import Snappy from '../../../libs/snappy/snappy';

Snappy.Component.Cookie = class Cookie extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-cookie';
	}
	
	setVars() {
		this.$button = this.$element.find('.accept-cta');
		this.cookieVisibilityKey = 'fa-cookie-visible';
		this.isCookieMessageVisible = this.getCookieMessageVisibility();
		this.activeClass = 'active';
	}
	
	setEventListeners() {
		this.$button.on('click', this.acceptCookies.bind(this));
	}
	
	acceptCookies() {
		this.hideCookieMessage();
		this.setCookieMessageVisibility(false);
	}
	
	getCookieMessageVisibility() {
		let visible = JSON.parse(localStorage.getItem(this.cookieVisibilityKey));
		
		if (visible === null) {
			// no preference stored, so message should be shown
			visible = true;
		}
		
		return visible;
	}
	
	setCookieMessageVisibility(visible) {
		localStorage.setItem(this.cookieVisibilityKey, visible);
	}
	
	showCookieMessage() {
		if (this.isCookieMessageVisible) {
			this.$element.addClass(this.activeClass);
		}
	}
	
	hideCookieMessage() {
		this.$element.removeClass(this.activeClass);
	}
	
	constructor(element) {
		super(element);
	}
	
	render() {
		this.setVars();
		this.setEventListeners();
		this.showCookieMessage();
	}
};



// WEBPACK FOOTER //
// ./components/cookie/scripts/cookie.js